/**
 * Countdown.
 *
 * @since 1.0.0
 * @version 1.0.0
 */

'use strict';

import 'jquery-countdown/dist/jquery.countdown';

class RbbCountdown {
	constructor() {
		this.render();
	}

	render( $selector ) {
		jQuery( document ).ready( function () {
			let $element = jQuery( '[data-countdown-date]' );
			if ( $selector !== undefined ) {
				$element = jQuery( $selector );
			}
			if ( $element.length ) {
				$element.each( function () {
					const $thisEl = jQuery( this );
					const $finalDate = $thisEl.data( 'countdownDate' ) || {};
					let $template =
						'<div class="item-time days"><span class="data-number">%D</span><span class="name-time">Day%!H</span></div>' +
						'<div class="item-time"><span class="data-number">%H</span><span class="name-time">Hour%!H</span></div>' +
						'<div class="item-time"><span class="data-number">%M</span><span class="name-time">Min%!H</span></div>' +
						'<div class="item-time"><span class="data-number">%S</span><span class="name-time">Sec</span></div>';
					if ( $thisEl.html().length ) {
						$template = $thisEl.html();
					}
					/**
					 * No use defer. It will error when ajax call.
					 */
					$thisEl.countdown( $finalDate, function ( event ) {
						$thisEl.html( event.strftime( $template ) );
					} );
				} );
			}
		} );
	}
}

/**
 * Set Time Out to fix when use together with slick slider.
 */
setTimeout( function () {
	window.RbbCountdown = new RbbCountdown();
}, 2000 );
